<template>
  <div :class="backgroundColor" class="hero is-bold">
    <div class="hero-body">
      <div class="container">
        <div class="is-flex title-container">
          <b-icon :icon="icon" size="is-large" />
          <h1 class="title">{{ title }}</h1>
        </div>
        <h2 class="subtitle">{{ subtitle }}</h2>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HeroBanner',
  props: {
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      required: true
    },
    backgroundColor: {
      type: String,
      default: 'is-primary'
    },
    icon: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped lang="scss">
.title-container {
  align-items: center;
}
</style>
